import { Box } from '../../../../../mads';
import { useScreenInfo } from '../../../../../shared/util/useScreenInfo';
import { useFullScreenVJActive } from '../../../hooks/useFullScreenVJActive';

import React from 'react';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';


interface ConditionalSafeAreaWrapperProps {
    readonly children: React.ReactNode;
    readonly withTopSafeArea: boolean;
    readonly panHandlers?: object;
}

export function ConditionalSafeAreaWrapper({
    children,
    withTopSafeArea,
    panHandlers,
}: ConditionalSafeAreaWrapperProps) {
    const isFullScreenVJActive = useFullScreenVJActive();
    const { isPortrait } = useScreenInfo();
    const brandedColorBackgroundMaxHeight = isPortrait ? 100 : 70;

    if (isFullScreenVJActive) {
        // In Hero VJ there are no top safe area
        return (
            <Box
                sx={[styles.heroContainer, { paddingTop: brandedColorBackgroundMaxHeight }]}
                {...(panHandlers as object)}
            >
                {children}
            </Box>
        );
    }

    // Normal VJ: with top safe area, solid nav
    return (
        <SafeAreaView
            edges={withTopSafeArea ? ['top'] : []}
            style={styles.normalContainer}
            {...(panHandlers as object)}
        >
            {children}
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    heroContainer: {
        flex: 1,
    },
    normalContainer: {
        flex: 1,
    },
});
